import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-01fc9199"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "page-6"
}
const _hoisted_2 = { class: "content" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "title" }, " 오프라인 수거장소 ", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "subtitle" }, [
  /*#__PURE__*/_createTextVNode(" 수거 품목을 모아, "),
  /*#__PURE__*/_createElementVNode("br", { class: "d-block d-md-none" }),
  /*#__PURE__*/_createTextVNode("오프라인 장소로 가져오셔서 수거에 참여해주시면 됩니다. ")
], -1))
const _hoisted_5 = { class: "map" }

import { computed } from 'vue';
import OfflineCollectionPoint from '../../on-going-program/components/offline-collection-point.vue';
import { IProgram } from '@/types/program';
import { Location } from '../../on-going-program/components/google-map.vue';

export interface Props {
  program: IProgram;
}
export default /*#__PURE__*/_defineComponent({
  props: {
    program: null
  },
  setup(__props: any) {

const props = __props as {
  program: IProgram;
}

;



const locationList = computed<Location[]>(() => {
  let idStep = 0;
  const programPoints = (props.program?.program_detail_info_attributes?.offline_collection_points || []).map((item) => {
    const location = (item.geographic_coordinates || '').split(',');
    return {
      id: ++idStep,
      title: item.name,
      address: item.address,
      phoneNumber: item.phone_number,
      lng: location[0] ? Number(location[0]) : undefined,
      lat: location[1] ? Number(location[1]) : undefined,
      postal_code: item.postal_code,
      opening_hours: item.opening_hours,
      show_phone_on_map: true
    };
  });
  return programPoints;
});

return (_ctx: any,_cache: any) => {
  return (_unref(locationList).length)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _createVNode(OfflineCollectionPoint, { "location-list": _unref(locationList) }, null, 8, ["location-list"])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})